import AvaliacaoTreinamentoAnalise from '@/pages/AvaliacaoTreinamentoAnalise/Index.vue'

export default [
  {
    path: '/avaliacao-treinamento/analise',
    component: () => import('@/pages/AvaliacaoTreinamentoAnalise/Template.vue'),
    children: [
      {
        path: '/avaliacao-treinamento/analise',
        component: AvaliacaoTreinamentoAnalise,
      },
    ],
  },
]
